import React, { useState, useEffect } from 'react';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import { apiHolder as api, getIn18Text } from 'api';
const systemApi = api.api.getSystemApi();
const timeZoneTrans = systemApi.timeZoneTrans;
const TimeText = ({ content }) => {
    var _a, _b, _c, _d;
    const { entry: { sendTime }, scheduleDateTimeZone, } = content;
    if (!sendTime)
        return React.createElement(React.Fragment, null);
    const systemTimeZone = systemApi.getSystemTimeZone();
    if (!systemTimeZone)
        return React.createElement(React.Fragment, null);
    if (sendTime && !scheduleDateTimeZone) {
        return React.createElement("span", { className: "blue" }, systemTimeZone.value + ' ' + ((_a = timeZoneTrans(sendTime, 8, systemTimeZone.key)) === null || _a === void 0 ? void 0 : _a.format('YYYY-MM-DD HH:mm')));
    }
    if (sendTime && scheduleDateTimeZone) {
        if (String(systemTimeZone.key) === String(scheduleDateTimeZone)) {
            return React.createElement("span", { className: "blue" }, systemTimeZone.value + ' ' + ((_b = timeZoneTrans(sendTime, 8, systemTimeZone.key)) === null || _b === void 0 ? void 0 : _b.format('YYYY-MM-DD HH:mm')));
        }
        const timeZoneList = systemApi.getTimeZoneList();
        const findTimeZone = timeZoneList.find(item => item.key === scheduleDateTimeZone);
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "blue" }, (findTimeZone === null || findTimeZone === void 0 ? void 0 : findTimeZone.value) + ' ' + ((_c = timeZoneTrans(sendTime, 8, scheduleDateTimeZone)) === null || _c === void 0 ? void 0 : _c.format('YYYY-MM-DD HH:mm'))),
            React.createElement("span", null,
                "\u00A0(",
                systemTimeZone.value + ' ' + ((_d = timeZoneTrans(sendTime, 8, systemTimeZone.key)) === null || _d === void 0 ? void 0 : _d.format('YYYY-MM-DD HH:mm')),
                ")")));
    }
    return React.createElement(React.Fragment, null);
};
const ScheduleDate = ({ content }) => {
    const [isSchedule, setIsSchedule] = useState(false);
    useEffect(() => {
        var _a;
        if ((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.isScheduleSend) {
            setIsSchedule(true);
        }
        else {
            setIsSchedule(false);
        }
    }, [content]);
    return isSchedule ? (React.createElement("div", { className: "mail-schedule" },
        React.createElement("span", { className: "clock-container" },
            React.createElement(ReadListIcons.ScheduleSvgCof, { fill: "#0FD683", color: "#0FD683", clockwiseColor: "#FFF" })),
        getIn18Text('ZHEFENGYOUJIANJIANG'),
        "\u00A0",
        React.createElement(TimeText, { content: content }),
        "\u00A0",
        getIn18Text('TOUDIDAODUIFANG'))) : (React.createElement(React.Fragment, null));
};
export default ScheduleDate;
